export default "__VITE_ASSET__f1e9a077__"